import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { isAmbienteDev, recuperarConfEmpresa } from '../../util/applicationContext';
import locaisEmbarquePorCidadeTurissulpassagens from './LocaisEmbarquePorCidade/locaisEmbarquePorCidadeTurissulpassagens'

export class CardsTopTrechos extends Component {
    constructor(props) {
        super(props);
        this.state = {
            groupedTrechos: []
        };
    }

    verificaQualSite() {
        const configEmpresa = recuperarConfEmpresa();        
        const ehTurissulpassagens = configEmpresa.pastaEstilo === 'turissulpassagens'

        if (ehTurissulpassagens) {
            return locaisEmbarquePorCidadeTurissulpassagens;
        }

        return [];
    }

    retornarGrupoDe5(valores) {
        const configEmpresa = recuperarConfEmpresa();
        const ehPolitur = configEmpresa.pastaEstilo === 'politurtransfer';
        let valorPadrao = 5;

        if (ehPolitur) valorPadrao = 3;

        const grupo = [];
        for (let i = 0; i < valores.length; i += valorPadrao) {
            const array = valores.slice(i, i + valorPadrao);
            grupo.push(array);
        }
        return grupo;
    }

    render() {
        const trechosParaExibir = this.verificaQualSite();
        const groupedTrechos = this.retornarGrupoDe5(trechosParaExibir);
        return (
            <div id='container-topTrechos1' className='container-toptrechos'>
                <div id='containerTituloTrechos' className='titulo-topTrechos'>
                    <span>
                        <b id='tituloTrechos'> Locais de Embarque Por Cidade </b>
                    </span>                    
                </div>
                <div className='container-groupedTrechos'>
                    {groupedTrechos.map((group, groupIndex) => (
                        <div key={groupIndex} id={`containertopTrechos${groupIndex}`} className='containertopTrechos'>
                            {group.map((trecho, index) => {
                                let baseURL = recuperarConfEmpresa().urlBase;
                                if (isAmbienteDev) {
                                    baseURL = recuperarConfEmpresa().urlBaseSandbox;
                                }                                
                                const hrefLink = `${baseURL}/locais-embarque-por-cidade`
                                return (
                                    <div className='col-md-4 mb-4' key={index}>
                                        <div className='card-topTrechos'>
                                            <a href={hrefLink} id='topTrechosLink'>
                                                <div className={recuperarConfEmpresa().pastaEstilo === 'politurtransfer' ? 'cardTrechoPolitur' : 'cardTrecho'}>
                                                    <div className='container-origemDestino'>
                                                        <div className='icon-topOrigem'>
                                                            <span id='destinoIcons' className="fa fa-map-marker"></span>
                                                            <h3 className='trechoOrigem'>{trecho.nomeCidadeOrigemComUF}</h3>
                                                        </div>                                                        
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}

export default withRouter(CardsTopTrechos);
